module.exports = __webpack_public_path__ + "img/Brand_mob_slack.f3853bf9.svg";